const isMeaningfulNamePart = (part) => {
  const value = String(part ?? '').trim()
  return value.length > 0 && value !== '-'
}

export const getActiveSellerPassport = (seller) =>
  seller?.person_passport?.find((p) => p.is_active) ?? seller?.person_passport?.[0]

/** ФИО и ИНН селлера для однократного предзаполнения формы расчётного счёта */
export const getSellerBankAccountPrefill = (bid) => {
  const seller = bid?.seller
  if (!seller) return {}

  const passport = getActiveSellerPassport(seller)
  const first_name = passport?.first_name ?? seller.first_name
  const last_name = passport?.last_name ?? seller.last_name
  const middle_name = passport?.middle_name ?? seller.middle_name
  const nameParts = [last_name, first_name, middle_name].filter(isMeaningfulNamePart)
  const legal_name = nameParts.join(' ').trim()

  const inn = String(passport?.inn ?? '').replace(/\D/g, '')

  return {
    ...(legal_name ? {legal_name} : {}),
    ...(inn ? {inn} : {}),
  }
}

export const getActiveRequisites = (bid) => (bid?.requisite_list ?? []).filter(Boolean)

export const findActiveRequisiteByType = (bid, type) =>
  getActiveRequisites(bid).find((r) => r?.requisite_type_name === type && r?.is_active)

/** Приоритет отображения в списке операций: карта → СБП → расчётный счёт */
export const LIST_PAYMENT_TYPE_ORDER = ['pan', 'phone', 'bank_account']

export const getRequisitePaymentTypeName = (req) =>
  req?.requisite_type_name ?? req?.requisite_type?.name ?? null

export const buildBidRequisiteTypeIdMap = (bid) => {
  const map = new Map()
  ;(bid?.requisite_list ?? []).forEach((req) => {
    const name = getRequisitePaymentTypeName(req)
    if (name && req?.bid_requisite_type_id != null) {
      map.set(req.bid_requisite_type_id, name)
    }
  })
  return map
}

export const requisiteMatchesPaymentType = (req, type, typeIdMap) => {
  if (!req?.is_active) {
    return false
  }
  const typeName = getRequisitePaymentTypeName(req)
  if (typeName === type) {
    return true
  }
  if (req?.bid_requisite_type_id != null && typeIdMap.get(req.bid_requisite_type_id) === type) {
    return true
  }
  return false
}

export const resolveListPaymentRequisite = (bid) => {
  const typeIdMap = buildBidRequisiteTypeIdMap(bid)
  const active = getActiveRequisites(bid)

  for (const type of LIST_PAYMENT_TYPE_ORDER) {
    const req = active.find((r) => requisiteMatchesPaymentType(r, type, typeIdMap))
    if (req) {
      return {paymentType: type, req}
    }
  }

  return {paymentType: null, req: null}
}

export const buildListRequisites = (bid) => {
  const {paymentType, req: activeReq} = resolveListPaymentRequisite(bid)
  const panReq = findActiveRequisiteByType(bid, 'pan')
  const phoneReq = findActiveRequisiteByType(bid, 'phone')
  const bankAccountReq = findActiveRequisiteByType(bid, 'bank_account')
  const emailReq = findActiveRequisiteByType(bid, 'email')

  const fioSource = paymentType === 'phone' ? phoneReq : paymentType === 'pan' ? panReq : null

  return {
    paymentType,
    pan: paymentType === 'pan' ? panReq?.requisite : null,
    phone: paymentType === 'phone' ? phoneReq?.requisite : null,
    bank_account: paymentType === 'bank_account' ? (activeReq?.requisite ?? bankAccountReq?.requisite) : null,
    legal_name: paymentType === 'bank_account' ? (activeReq?.legal_name ?? bankAccountReq?.legal_name) : null,
    bank_name: paymentType === 'bank_account' ? (activeReq?.bank_name ?? bankAccountReq?.bank_name) : null,
    email: emailReq?.requisite,
    first_name: fioSource?.receiver_first_name,
    last_name: fioSource?.receiver_last_name,
    middle_name: fioSource?.receiver_middle_name,
  }
}

export const getPaymentType = (bid) => {
  if (findActiveRequisiteByType(bid, 'bank_account')) return 'bank_account'
  if (findActiveRequisiteByType(bid, 'pan')) return 'pan'
  if (findActiveRequisiteByType(bid, 'phone')) return 'phone'
  return null
}

export const buildReviewRequisites = (bid) => {
  const panReq = findActiveRequisiteByType(bid, 'pan')
  const phoneReq = findActiveRequisiteByType(bid, 'phone')
  const emailReq = findActiveRequisiteByType(bid, 'email')
  const bankAccountReq = findActiveRequisiteByType(bid, 'bank_account')

  return {
    paymentType: getPaymentType(bid),
    pan: panReq?.requisite,
    phone: phoneReq?.requisite,
    email: emailReq?.requisite,
    bankAccount: bankAccountReq,
    receiver_last_name: phoneReq?.receiver_last_name,
    receiver_first_name: phoneReq?.receiver_first_name,
    receiver_middle_name: phoneReq?.receiver_middle_name,
    bankName: phoneReq?.bank_name,
  }
}

export const getPaymentTitle = (paymentType) => {
  if (paymentType === 'pan') return 'на карту'
  if (paymentType === 'bank_account') return 'на расчетный счет'
  return 'по СБП'
}

export const getCommissionKey = (paymentType) => {
  if (paymentType === 'phone') return 'sbp'
  if (paymentType === 'pan') return 'card'
  if (paymentType === 'bank_account') return 'bank_account'
  return null
}

export const getCommissionLabel = (paymentType) => {
  if (paymentType === 'phone') return 'СБП'
  if (paymentType === 'pan') return 'карты'
  if (paymentType === 'bank_account') return 'расч. счёта'
  return ''
}
